import React from "react";
import {
    LinkedinIcon,
    InstagramIcon,
    FacebookIcon,
    WhatsAppIcon,
    YoutubeIcon,
    TwitterXIcon,
} from "../Common/SocialIcons";
import { useLocation, Link } from "react-router-dom";
// import axios from 'axios';

export default function FooterNew() {
    const location = useLocation();

    const socialMediaLinks = {
        "/colleges/vels-university": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/vels_aviation/",
            facebook: "https://www.facebook.com/VelsAviation/",
            twitter: "https://x.com/Vels_Aviation",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/crescent-university": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/crescent_aviation/",
            facebook: "https://www.facebook.com/CrescentAviation/",
            twitter: "https://x.com/Crescent_Avi",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/jamal-mohamed-college": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/jamalaviation1/",
            facebook: "https://www.facebook.com/JamalMohamedAviation",
            twitter: "https://x.com/Jamal_Aviation",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/bharath-university": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/bharathuniversity_aviation/",
            facebook: "https://www.facebook.com/BharathUniversityAviation",
            twitter: "https://x.com/BharathAviation",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/bishop-heber-college": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/bishop_heber_aviation/",
            facebook: "https://www.facebook.com/BishopHeberAviation",
            twitter: "https://x.com/BishopHAviation",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/alliance-university": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/alliance_university_aviation/",
            facebook: "https://www.facebook.com/AllianceUniversityAviation",
            twitter: "https://x.com/AllianceUnivAvi",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/sasurie-college": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/mh_cockpit/",
            facebook: "https://www.facebook.com/MHCockpitAviationAcademy/",
            twitter: "https://x.com/mhcockpitpvtltd",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/sanskriti-university": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/mh_cockpit/",
            facebook: "https://www.facebook.com/MHCockpitAviationAcademy/",
            twitter: "https://x.com/mhcockpitpvtltd",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        "/colleges/rathinam-university": {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/mh_cockpit/",
            facebook: "https://www.facebook.com/MHCockpitAviationAcademy/",
            twitter: "https://x.com/mhcockpitpvtltd",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
        // "/colleges/kalasalingam-university": {
        //     whatsapp: "7823900439",
        //     instagram: "",
        //     facebook: "",
        //     twitter: "",
        //     youtube: "https://www.youtube.com/@mhcockpit",
        //     linkedin: "https://www.linkedin.com/company/mhcockpit/",
        // },
        // "/malla-reddy-university": {
        //   whatsapp: "9884807480",
        //   instagram: "https://www.instagram.com/mallareddy_aviation/",
        //   facebook: "https://www.facebook.com/MallaReddyAviation/",
        //   twitter: "https://x.com/mallareddy56541",
        //   youtube: "https://www.youtube.com/@mhcockpit",
        //   linkedin: "https://www.linkedin.com/company/mhcockpit/",
        // },
        default: {
            whatsapp: "7823900439",
            instagram: "https://www.instagram.com/mh_cockpit/",
            facebook: "https://www.facebook.com/MHCockpitAviationAcademy/",
            twitter: "https://x.com/mhcockpitpvtltd",
            youtube: "https://www.youtube.com/@mhcockpit",
            linkedin: "https://www.linkedin.com/company/mhcockpit/",
        },
    };

    const mapUrls = {
        "/colleges/vels-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8473781069715!2d80.25723747454673!3d12.981611814659749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525da4ecdc8161%3A0x89adb06bcfc82ffb!2sVels%20University%20-%20Thiruvanmiyur%20Campus!5e0!3m2!1sen!2sin!4v1787740874454!5m2!1sen!2sin",
        "/colleges/bharath-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.997976927652!2d80.13745217484029!3d12.90785128740165!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525fbee3233e29%3A0x57239a1c8e5d626b!2sBharath%20Institute%20of%20Higher%20Education%20And%20Research!5e0!3m2!1sen!2sjp!4v1783667743761!5m2!1sen!2sjp",
        "/colleges/sasurie-college": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.581416195461!2d77.48934197481174!3d11.21857428895836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba90d1000000007%3A0x9e980065d728c260!2sSasurie%20College%20of%20Arts%20and%20Science!5e0!3m2!1sen!2sjp!4v1783667773646!5m2!1sen!2sjp",
        "/colleges/alliance-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3891.7384298251595!2d77.7067921!3d12.730479599999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae6e511486348b%3A0xd89a0e9710f980c7!2sAlliance%20University!5e0!3m2!1sen!2sin!4v1783747350416!5m2!1sen!2sin",
        "/colleges/crescent-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.5024107484496!2d80.08126007491663!3d12.875382987431228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52f61234ec7d7f%3A0xacd2f620b894194e!2sCrescent%20College!5e0!3m2!1sen!2sin!4v1783747624598!5m2!1sen!2sin",
        "/colleges/kalasalingam-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3934.255093764607!2d77.67950117486566!3d9.573265390511379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06dbc06968e9eb%3A0x6cfd8f94e42f98c4!2sKalasalingam%20Academy%20of%20Research%20and%20Education!5e0!3m2!1sen!2sin!4v1783747558524!5m2!1sen!2sin",
        "/colleges/sanskriti-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.9252510594915!2d77.51606097532307!3d27.688705076193187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3973158e68c54641%3A0xb974890cac71f855!2sSanskriti%20University!5e0!3m2!1sen!2sin!4v1783747727769!5m2!1sen!2sin",
        "/colleges/bishop-heber-college": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.9556463717954!2d78.6705019748831!3d10.814706289336375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baaf5766da376cb%3A0x158877d0ddcfd3b8!2sBishop%20Heber%20College!5e0!3m2!1sen!2sin!4v1783747423604!5m2!1sen!2sin",
        "/colleges/jamal-mohamed-college": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.323798055105!2d78.69324007488264!3d10.786493489362899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baaf525d4d25391%3A0xcfbc5b3e170dd940!2sJamal%20Mohamed%20College!5e0!3m2!1sen!2sin!4v1783747395653!5m2!1sen!2sin",
        "/colleges/ganpat-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.089379970295!2d72.45516137518047!3d23.529287478821825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c476c5013fd03%3A0xa1fe01d9ab30482!2sGanpat%20University%20(GUNI)%2C%20India!5e0!3m2!1sen!2sin!4v1783747593587!5m2!1sen!2sin",
        "/colleges/rathinam-university": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.380101341648!2d76.9761095745191!3d10.934633456256698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba839d134a9407f%3A0x7738f23838219623!2sRathinam%20Global%20Deemed%20to%20be%20University!5e0!3m2!1sen!2sin!4v1787722597108!5m2!1sen!2sin",
        default: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.305692585349!2d80.16034307512247!3d12.952280487361296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52675aeb55363f%3A0x491352dd8672f0dd!2sMH%20Cockpit%20-%20Aviation%20Academy!5e0!3m2!1sen!2sin!4v1712053178519!5m2!1sen!2sin"
    };

    const links = socialMediaLinks[location.pathname] || socialMediaLinks.default;
    const mapUrl = mapUrls[location.pathname] || mapUrls.default;

    // const [linkedinMail, setlinkedinMail] = useState('');
    // const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    // const addData = async () => {
    //     // Check if any required field is empty
    //     const requiredFields = [linkedinMail];
    //     const hasEmptyFields = requiredFields.some(field => field === '');
    //     // setIsButtonDisabled(true);

    //     if (hasEmptyFields) {
    //         alert('Please fill in all required fields.');
    //         return;
    //     }

    //     try {
    //         const newData = {
    //             Linkedin_Mail: linkedinMail
    //         };
    //         await axios.post('https://sheetdb.io/api/v1/d6aigwrmryn5s', newData);
    //         setlinkedinMail('');
    //         // alert("Your form has been submitted successfully! Our team will contact you within 24 hours!");
    //     } catch (error) {
    //         console.error('Error in Submission', error);
    //     }
    // };

    const handleLogoClick = (e) => {
        if (location.pathname === '/') {
            e.preventDefault();
            if (window.location.hash) {
                window.history.pushState(null, '', '/');
            }
            if (window.lenis) {
                window.lenis.scrollTo(0);
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    };

    return (
        <footer id="site-footer" className="bg-black text-white px-6 py-10">
            <div className="mx-auto grid lg:grid-cols-2 gap-40 xl:gap-40 sm:gap-10 max-sm:gap-10 pl-14 max-sm:pl-0 items-center">

                {/* LEFT SECTION */}
                <div className="space-y-6">
                    <div className="space-y-3">
                        <Link to="/" title="MH Cockpit - Home" onClick={handleLogoClick}>
                            <img
                                className="w-40 h-auto object-contain"
                                src="/MH_Cockpit_TM_LOGO_white.png"
                                alt="MH Cockpit Logo"
                                title="MH Cockpit Logo"
                                loading="lazy"
                            />
                        </Link>
                        <p className="text-4xl max-sm:text-3xl font-semibold uppercase leading-snug">
                            Start your journey to <br className="max-sm:hidden" />
                            the skies, <span className="text-[#FF6557]">today</span>
                        </p>
                    </div>

                    {/* FOOTER LINKS WITH SEPARATOR */}
                    <div className="grid sm:grid-cols-3 max-sm:grid-cols-2 gap-6">

                        {/* Quick Links */}
                        <div className="flex flex-col space-y-2 border-r border-gray-700 max-sm:border-none max-sm:pr-0">
                            <p className="font-bold text-xl">Quick Links</p>
                            {location.pathname !== "/" && (
                                <a href="/" className="block" title="MH Cockpit - Home">Home</a>
                            )}
                            <a href="/consulting" title="Consulting">Consulting</a>
                            <a href="/innovation" title="Innovation Hub">Innovation</a>
                            <a href="/careers" title="Careers Overview">Careers</a>
                            <a href="/about-us" title="About Us">About Us</a>
                        </div>

                        {/* Information Links */}
                        <div className="flex flex-col space-y-2 border-r border-gray-700 max-sm:border-none max-sm:px-0 w-full">
                            <p className="font-bold text-xl">Information Links</p>
                            <a href="/training#pilot-training" title="Training Overview">Pilot Training</a>
                            <a href="/training#degree-programs" title="Training Overview">Degree Programs</a>
                            <a href="/training#certification-programs" title="Training Overview">Certification Programs</a>
                            <a href="/colleges" title="College Partners Overview">Colleges</a>
                            <a href="/blogs" title="Blog Home">Blogs</a>
                        </div>

                        {/* Get in Touch */}
                        <div className="space-y-3 max-sm:pl-0 w-full">
                            <p className="font-bold text-xl">Get in touch</p>
                            <p className="flex gap-1">
                                <a href="tel:9884807480">9884807480</a> /{" "}
                                <a href="tel:9884927480">9884927480</a>
                            </p>
                            <p>
                                <a href="mailto:info@mhcockpit.com">info@mhcockpit.com</a>
                            </p>

                            {/* Social Icons */}
                            <div className="grid grid-cols-6 gap-2">
                                <a href={links.linkedin} target="_blank" rel="noreferrer" aria-label="Linkedin"><LinkedinIcon size={20} /></a>
                                <a href={links.twitter} target="_blank" rel="noreferrer" aria-label="Twitter"><TwitterXIcon size={20} /></a>
                                <a href={links.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><InstagramIcon size={20} /></a>
                                <a href={links.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><FacebookIcon size={20} /></a>
                                <a href={links.youtube} target="_blank" rel="noreferrer" aria-label="Youtube"><YoutubeIcon size={20} /></a>
                                <a href={`https://wa.me/${links.whatsapp}`} target="_blank" rel="noreferrer" aria-label="Whatsapp"><WhatsAppIcon size={20} /></a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT SECTION (Newsletter + Map) */}
                <div className="space-y-6 pl-10 max-sm:pl-0 pr-20 max-sm:pr-0">
                    {/* <div className="space-y-2">
                        <p className="text-xl font-semibold">Join our newsletter</p>
                        <p className="text-gray-300">Keep up to date with everything MH Cockpit</p>
                        <div className="flex items-center">
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={linkedinMail} onChange={(e) => setlinkedinMail(e.target.value)}
                                className="w-full px-4 py-1.5 rounded-l-md bg-transparent border-2 border-gray-500"
                            />
                            <button onClick={addData} className="bg-[#FF6557] px-5 py-2 rounded-r-md font-semibold hover:bg-[#ff7a6d] transition">
                                Subscribe
                            </button>
                        </div>
                    </div> */}

                    {/* MAP */}
                    <div>
                        {location.pathname.includes('/colleges/') && (
                            <h3 className="text-2xl font-semibold mb-4">Campus Location: </h3>
                        )}
                        <iframe
                            src={mapUrl}
                            width="100%"
                            height="200"
                            loading="lazy"
                            allowFullScreen=""
                            className="rounded-lg shadow-lg"
                            title="MH Cockpit"
                        ></iframe>
                    </div>
                </div>
            </div>

            {/* BOTTOM BAR */}
            <div className="border-t text-gray-400 border-gray-700 mt-10 pt-5 text-center text-sm flex flex-col sm:flex-row justify-between items-center max-w-7xl mx-auto">
                <p className="">© {new Date().getFullYear()} MH Cockpit. All rights reserved.</p>

                {/* <div className="flex gap-6 text-gray-400 mt-3 sm:mt-0"> */}
                <a href="/privacy-policy" className="hover:text-white" title="Privacy Policy">Privacy Policy</a>
                <a href="/terms-and-conditions" className="hover:text-white" title="Terms and Conditions">Terms & Conditions</a>
                <a href="/communication-policy" className="hover:text-white" title="Communication Policy">Communication Policy</a>
                {/* </div> */}
            </div>
        </footer>
    );
}
